import {tokens} from '@commercial-helios/ui/theme'
import React from 'react'
import styled from 'styled-components'

import type {Props as RadioGroupProps} from '@/components/radio-group'
import RadioGroup from '@/components/radio-group'
import Image from '@helios/shared/components/image'
import type {Props as RichTextProps} from '@helios/shared/components/rich-text'
import RichText from '@helios/shared/components/rich-text'
import type {Props as SelectProps} from '@helios/shared/components/select'
import Select from '@helios/shared/components/select'
import {Layout, Section} from '@helios/shared/styles/grid'
import {Text} from '@helios/shared/styles/typography'
import type ImageSource from '@helios/shared/types/image'
import mq from '@helios/shared/utils/media-query'

import type {Location, Office} from '../shared'
import {MOBILE_BREAKPOINT} from '../shared'

interface Props {
    image: ImageSource
    title: string
    content: RichTextProps['content']
    locationSelect: SelectProps<Location>
    officeRadioGroup: Omit<RadioGroupProps<Office>, 'name'>
}

export const Hero = ({image, title, content, locationSelect, officeRadioGroup}: Props) => {
    return (
        <Section padding="small" data-testid="flex-benefits-page-hero">
            <Layout variant="two-asymmetrical" alignItems="center">
                <div>
                    <StyledTitle variant="heading-large" forwardedAs="h1">
                        {title}
                    </StyledTitle>

                    <RichTextWrapper>
                        <RichText content={content} color="muted" variant="paragraph-large" />
                    </RichTextWrapper>

                    <Select {...locationSelect} />

                    <RadioGroupWrapper>
                        <RadioGroup name="office-radio-group" {...officeRadioGroup} />
                    </RadioGroupWrapper>
                </div>

                <StyledImage image={image} width={550} />
            </Layout>
        </Section>
    )
}

const StyledTitle = styled(Text)`
    margin-bottom: ${tokens.spacing20};
`

const RichTextWrapper = styled.div`
    margin-bottom: ${tokens.spacing36};

    ${mq.min(MOBILE_BREAKPOINT)} {
        margin-bottom: ${tokens.spacing40};
    }
`

const RadioGroupWrapper = styled.div`
    margin-top: ${tokens.spacing28};

    ${mq.min(MOBILE_BREAKPOINT)} {
        margin-top: ${tokens.spacing20};
    }
`

const StyledImage = styled(Image)`
    width: 100%;
`
